/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMsal } from '@azure/msal-react';
import { useEffect, useState, useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { apiAzureGet } from '../../../services/ApiAzureGet';
import { getInfoUsers } from '../../../services/ApiGetUserInfo';
import Moment from 'moment';
import 'moment/locale/th';
import { useTranslation } from 'react-i18next';
import { NotifyModal } from '../../../modal/NotifyModal';
import { getBuildDate } from '../../../utils';
import packageJson from '../../../../package.json';
import { toast } from 'react-toastify';
import { appConfig } from '../../../authConfig';
import { useUser } from '../../../context/UserContext';

export const Profile: React.FC = () => {
  const { instance } = useMsal();
  const { userInfo, isLoading } = useUser();
  const [showModal, setShowModal] = useState(false);
  const [UserProfilePic, setUserProfilePic] =  useState<any | null>(null);
  const [btnConfirm, setbtnConfirm] = useState('no');
  const [modalTitle, setModalTitle] = useState('');
  const [modalBody, setmodalBody] = useState('');

  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = process.env.REACT_APP_NAME || '';
    Moment.locale(localStorage.getItem('Language') === 'en' ? 'en-sg' : 'th');
  }, []);

  useEffect(() => {
    // อัปเดตรูปโปรไฟล์ทันทีเมื่อ userPhoto ใน localStorage เปลี่ยน (แบบ event-driven)
    const updateProfilePic = () => {
      const photo = localStorage.getItem("userPhoto");
      if (photo && photo !== "no-photo" && photo !== "") {
        setUserProfilePic(photo);
      } else {
        setUserProfilePic("../images/icon/logo.png");
      }
    };
    updateProfilePic();

    // ฟัง event storage เฉพาะ userPhoto (รองรับ multi-tab และเร็วกว่า polling)
    const onStorage = (e: StorageEvent) => {
      if (e.key === "userPhoto") {
        updateProfilePic();
      }
    };
    window.addEventListener("storage", onStorage);

    // กรณี userPhoto ถูก set ใน tab เดียวกัน ให้ monkey-patch localStorage.setItem
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function(key: string, value: string) {
      originalSetItem.call(this, key, value);
      if (key === "userPhoto") {
        window.dispatchEvent(new StorageEvent("storage", { key: "userPhoto", newValue: value }));
      }
    };

    return () => {
      window.removeEventListener("storage", onStorage);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  useEffect(() => {
    
    const version = localStorage.getItem('version');
    if (version !== packageJson.version) {
      if ('caches' in window) {
        caches.keys().then((names) => {
          names.forEach((name) => caches.delete(name));
        });
        window.location.reload();
      }
      localStorage.clear();
      localStorage.setItem('version', packageJson.version);
    }
  }, []);

  const changeLanguage = useCallback((lang: 'th' | 'en') => {
    i18n.changeLanguage(lang);
    localStorage.setItem('Language', lang);
    Moment.locale(lang === 'en' ? 'en-sg' : 'th');
  }, [i18n]);

  const checkVersionBuild = useCallback(() => {
    toast.success(`Build Version: ${packageJson.version} (${getBuildDate(packageJson.buildDate)})`);
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.clear();
    sessionStorage.clear();
    setTimeout(() => {
      window.location.href =
        'https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=' + appConfig.appEndpoint.baseUrl;
    }, 1000);
  }, []);

  const getTextStyle = useCallback(() => ({
    filter: isLoading ? "blur(3px)" : "none",
    transition: "filter 0.5s ease-in-out",
  }), [isLoading]);

  if (isLoading || !userInfo) {
    return (
      <div className="profile-placeholder text-center">
        <p className='text-center'>{isLoading ? 'Loading user information...' : 'User information is not available.'}</p>
      </div>
    );
  }

  return (
    <>
      <NotifyModal
        btnText={t('btn_ok')}
        type="text"
        btnConfirm={btnConfirm}
        keyboard={true}
        backdrop="true"
        confirm={handleLogout}
        confirmFunc={handleLogout}
        title={modalTitle}
        body={modalBody}
        showModal={showModal}
        handleContinue={handleLogout}
        onHide={handleLogout}
        onExiting=""
        Style={{ background: '#B7B8B9' }}
      />
      <div className="fix-box-header">
        <Container fluid className="header-bg">
          <Row>
            <Col xs={6}>
              <h4 className="hello mt-3 mb-2">HR Mobile </h4>
              <h4 className="welcome mb-0">
                {t('greet')}{' '}
                {process.env.REACT_APP_ENV ? '(' + process.env.REACT_APP_ENV + ')' : ''}
              </h4>
            </Col>
            <Col xs={6} className="d-flex justify-content-end align-content-end mt-3">
              <div className="switch-language d-flex justify-content-end">
                <span className="p-1 pr-2" cy-id="th" onClick={() => changeLanguage('th')}>
                  <img src="../images/th.svg" alt="logo th" width={25}
                    className={localStorage.getItem('Language') === 'th' ? 'active' : ''} />
                  <p className={`title ${localStorage.getItem('Language') === 'th' ? 'active' : ''}`}>TH</p>
                </span>
                <span className="p-1" cy-id="en" onClick={() => changeLanguage('en')}>
                  <img src="../images/en.svg" alt="logo en" width={25}
                    className={localStorage.getItem('Language') === 'en' ? 'active' : ''} />
                  <p className={`title ${localStorage.getItem('Language') === 'en' ? 'active' : ''}`}>EN</p>
                </span>
                <span className="p-1 ml-2" style={{ width: '80px' }}>
                  <div className="icon-logout text-center" onClick={handleLogout}>
                    <img className="btn-login" src="../images/icon-logout.svg" width={25} alt="logout" />
                    <p className="text-logout">{t('logout_text')}</p>
                  </div>
                </span>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="profile-line-hr-box">
          <Container fluid>
            <Row>
              <Col>
                <div className="user-images">
                  <input
                    onClick={checkVersionBuild}
                    type="image"
                    className="img"
                    src={UserProfilePic || "../images/icon/logo.png"}
                    alt="user profile photo"
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <h3 className="profile-name" style={getTextStyle()}>
                  {localStorage.getItem('Language') === 'en'
                    ? userInfo.employeeNameEn
                    : userInfo.employeeNameTh}
                </h3>
              </Col>
            </Row>
            <Row>
              <Col>
                <h3 className="profile-positon" style={getTextStyle()}>{userInfo.position}</h3>
              </Col>
            </Row>
            <Row>
              <Col>
                <h3 className="profile-empoyee-code" style={getTextStyle()}>{userInfo.employeeId}</h3>
                <hr className="profile-line-hr" />
              </Col>
            </Row>
            <Row>
              <Col>
                <Container className="text-center">
                  <Row className="profile-title" >
                    <Col className="p-1 text-ceter" style={getTextStyle()}>{t('profile.phone')}</Col>
                    <Col className="p-1 text-ceter" style={getTextStyle()}>{t('profile.joined')}</Col>
                    <Col className="p-1 text-ceter" style={getTextStyle()}>{t('profile.service_year')}</Col>
                  </Row>
                  <Row className="profile-value">
                    <Col style={getTextStyle()}>{userInfo.mobileNo}</Col>
                    <Col style={getTextStyle()}>
                      {Moment(userInfo.employeeDate).format('DD MMM YYYY')}
                    </Col>
                    <Col style={getTextStyle()}>
                      {userInfo.serviceYear ? userInfo.serviceYear + (localStorage.getItem('Language') === 'en' ? ' Year' : ' ปี') : ''}
                      {userInfo.serviceMonth ? ' ' + userInfo.serviceMonth + (localStorage.getItem('Language') === 'en' ? ' Month' : ' เดือน') : ''}
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};
